import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiCaller";

export const GET_ONE_PROVIDER = "GET_ONE_PROVIDER";
export const GET_ONE_PROVIDER_SUCCESS = "GET_ONE_PROVIDER_SUCCESS";
export const GET_ONE_PROVIDER_ERROR = "GET_ONE_PROVIDER_ERROR";

export const GET_PROVIDER = "GET_PROVIDER";
export const GET_PROVIDER_SUCCESS = "GET_PROVIDER_SUCCESS";
export const GET_PROVIDER_ERROR = "GET_PROVIDER_ERROR";

export const COUNT_LIST_PROVIDER = "COUNT_LIST_PROVIDER";
export const COUNT_LIST_PROVIDER_SUCCESS = "COUNT_LIST_PROVIDER_SUCCESS";
export const COUNT_LIST_PROVIDER_ERROR = "COUNT_LIST_PROVIDER_ERROR";

export const CREATE_PROVIDER = "CREATE_PROVIDER";
export const CREATE_PROVIDER_SUCCESS = "CREATE_PROVIDER_SUCCESS";
export const CREATE_PROVIDER_ERROR = "CREATE_PROVIDER_ERROR";

export const DELETE_PROVIDER = "DELETE_PROVIDER";
export const DELETE_PROVIDER_SUCCESS = "DELETE_PROVIDER_SUCCESS";
export const DELETE_PROVIDER_ERROR = "DELETE_PROVIDER_ERROR";

export const EDIT_PROVIDER = "EDIT_PROVIDER";
export const EDIT_PROVIDER_SUCCESS = "EDIT_PROVIDER_SUCCESS";
export const EDIT_PROVIDER_ERROR = "EDIT_PROVIDER_ERROR";

/**
 * Reducer
 */

const initialState = {};

export const smsReducer = (state = initialState, action) => {
  switch (action.type) {
    //provider
    case COUNT_LIST_PROVIDER:
      return {
        ...state,
      };
    case COUNT_LIST_PROVIDER_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_PROVIDER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_PROVIDER:
      return {
        ...state,
      };
    case GET_PROVIDER_SUCCESS:
      return {
        ...state,
        provider: action.payload,
      };
    case GET_PROVIDER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case CREATE_PROVIDER:
      return {
        ...state,
      };
    case CREATE_PROVIDER_SUCCESS:
      return {
        ...state,
        provider: action.payload,
      };
    case CREATE_PROVIDER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case EDIT_PROVIDER:
      return {
        ...state,
      };
    case EDIT_PROVIDER_SUCCESS: {
      const listProvidersResult =
        typeof state.provider === "object"
          ? Object.keys(state.provider).map((key) => state.provider[key])
          : state.provider;
      const newData = listProvidersResult.map((i) => {
        if (i.id === action.data.id) {
          i.id = action.data.id;
          i.name = action.data.name;
          i.note = action.data.note;
        }
        return i;
      });
      return {
        ...state,
        newData,
      };
    }
    case EDIT_PROVIDER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case DELETE_PROVIDER:
      return {
        ...state,
      };
    case DELETE_PROVIDER_SUCCESS: {
      const newData = state.provider.filter((i) => i.id !== action.data.id);
      return {
        ...state,
        newData,
      };
    }
    case DELETE_PROVIDER_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //get one
    case GET_ONE_PROVIDER:
      return {
        ...state,
      };
    case GET_ONE_PROVIDER_SUCCESS:
      return {
        ...state,
        oneProvider: action.payload,
      };
    case GET_ONE_PROVIDER_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
//provider
export const getProviderSMS = (order, limit, skip, where) => ({
  type: GET_PROVIDER,
  data: {
    order,
    limit,
    skip,
    ...where,
  },
});

export const getOneProvider = (id) => ({
  type: GET_ONE_PROVIDER,
  data: {
    id,
  },
});

export const countProviderSMS = (where) => ({
  type: COUNT_LIST_PROVIDER,
  data: {
    where,
  },
});

export const createProviderSMS = (id, name, note) => ({
  type: CREATE_PROVIDER,
  data: {
    id,
    name,
    note,
  },
});

export const deleteProviderSMS = (id) => ({
  type: DELETE_PROVIDER,
  data: {
    id,
  },
});

export const editProviderSMS = (id, name, note) => ({
  type: EDIT_PROVIDER,
  data: {
    id,
    name,
    note,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getProviderSMS,
      getOneProvider,
      countProviderSMS,
      createProviderSMS,
      deleteProviderSMS,
      editProviderSMS,
    },
    dispatch
  );
};

/**
 * Apis
 */

//provider
const getProviderSMSApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/messaging/sms-provider", {
    order,
    limit,
    skip,
    where,
  });
};
const countListProviderApi = (where) => {
  return apiCaller.getLogs("/messaging/sms-provider/count", { where });
};
const createProviderSMSApi = (id, name, note) => {
  return apiCaller.post("/messaging/sms-provider", { id, name, note });
};
const editProviderSMSApi = (id, name, note) => {
  return apiCaller.put(`/messaging/sms-provider/${id}`, { name, note });
};
const deleteProviderSMSApi = (id) => {
  return apiCaller.del(`/messaging/sms-provider/${id}`);
};
const getOneProviderApi = (id) => {
  return apiCaller.getLogs(`/messaging/sms-provider/${id}`);
};
/**
 * sagas
 */

export const getOneProviderFlow = function* () {
  while (true) {
    const action = yield take(GET_ONE_PROVIDER);
    try {
      const res = yield call(getOneProviderApi, action.data.id);
      yield put({
        type: GET_ONE_PROVIDER_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: GET_ONE_PROVIDER_ERROR, error });
    }
  }
};

//provider
export const getListProviderFlow = function* () {
  while (true) {
    const action = yield take(GET_PROVIDER);
    try {
      const res = yield call(
        getProviderSMSApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_PROVIDER_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: GET_PROVIDER_ERROR, error });
    }
  }
};

export const countProviderFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_PROVIDER);
    try {
      const res = yield call(countListProviderApi, action.data.where);
      yield put({
        type: COUNT_LIST_PROVIDER_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_PROVIDER_ERROR, error });
    }
  }
};

export const createProviderFlow = function* () {
  while (true) {
    const action = yield take(CREATE_PROVIDER);
    try {
      const res = yield call(
        createProviderSMSApi,
        action.data.id,
        action.data.name,
        action.data.note
      );
      yield put({
        type: CREATE_PROVIDER_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: CREATE_PROVIDER_ERROR, error });
    }
  }
};

export const deleteProviderFlow = function* () {
  while (true) {
    const action = yield take(DELETE_PROVIDER);
    try {
      const res = yield call(deleteProviderSMSApi, action.data.id);
      yield put({
        type: DELETE_PROVIDER_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: DELETE_PROVIDER_ERROR, error });
    }
  }
};

export const editProviderFlow = function* () {
  while (true) {
    const action = yield take(EDIT_PROVIDER);
    try {
      const res = yield call(
        editProviderSMSApi,
        action.data.id,
        action.data.name,
        action.data.note
      );
      yield put({
        type: EDIT_PROVIDER_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: EDIT_PROVIDER_ERROR, error });
    }
  }
};
